import type { SimpleChanges } from '@angular/core';
import { Component, inject } from '@angular/core';

import type { GetInputs } from '@recruitee/common';
import { componentOutletConfigFactory, TimeService } from '@recruitee/common';
import type { JobSchedulerData } from '@recruitee/offers-types';
import { JobSchedulerErrorComponent } from '@recruitee/offers-ui';
import type { DataTableRow, TableCellFactory } from '@recruitee/user-interface';
import { RtTooltip, EMPTY_CELL, TABLE_CELL_TIME_FORMAT } from '@recruitee/user-interface';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [RtTooltip, JobSchedulerErrorComponent],
  template: `
    @if (!jobScheduler?.error) {
      <div [rtTooltip]="jobScheduler?.timezone">
        {{ date }}
      </div>
    } @else {
      <rt-job-scheduler-error [schedulerError]="jobScheduler?.error"></rt-job-scheduler-error>
    }
  `,
  inputs: ScheduleCellComponent.NgInputs,
})
export class ScheduleCellComponent {
  public static NgInputs = ['jobScheduler' as const, 'dateKey' as const];

  public jobScheduler: JobSchedulerData | null;
  public dateKey: 'publishDate' | 'closeDate';
  public date: string;

  private timeService = inject(TimeService);

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.jobScheduler) {
      this.date = this.timeService.format({
        input: this.jobScheduler?.[this.dateKey],
        pattern: TABLE_CELL_TIME_FORMAT,
      });
    }
  }
}

export const scheduleCellFactory =
  <Key extends keyof Row, Row extends DataTableRow & { [k in Key]: JobSchedulerData }>(
    key: Key,
    dateKey: GetInputs<typeof ScheduleCellComponent>['dateKey'],
  ): TableCellFactory<Row> =>
  ({ row }) => {
    if (!row[key]?.[dateKey]) return EMPTY_CELL;

    return componentOutletConfigFactory(ScheduleCellComponent, {
      inputs: { jobScheduler: row[key], dateKey },
    });
  };
